export const ANALYTICS = 'ANALYTICS';
export const CALENDAR = 'CALENDAR';
export const CALLS = 'CALLS';
export const CARTS = 'CARTS';
export const COMPANIES = 'COMPANIES';
export const COMPANY_PROPERTIES = 'COMPANY_PROPERTIES';
export const CONTACTS = 'CONTACTS';
export const CONTACT_LISTS = 'CONTACT_LISTS';
export const CONTACT_PROPERTIES = 'CONTACT_PROPERTIES';
export const CONVERSATIONS = 'CONVERSATIONS';
export const CONVERSATIONS_LIVE_CHAT_WIDGET = 'CONVERSATIONS_LIVE_CHAT_WIDGET';
export const CMS_BLOG = 'CMS_BLOG';
export const CMS_BLOG_AUTHORS = 'CMS_BLOG_AUTHORS';
export const CMS_BLOG_COMMENTS = 'CMS_BLOG_COMMENTS';
export const CMS_BLOG_POST = 'CMS_BLOG_POST';
export const CMS_BLOG_TOPICS = 'CMS_BLOG_TOPICS';
export const CMS_DOMAINS = 'CMS_DOMAINS';
export const CMS_FILES = 'CMS_FILES';
export const CMS_HUBDB = 'CMS_HUBDB';
export const CMS_LAYOUTS = 'CMS_LAYOUTS';
export const CMS_PAGE_PUBLISHING = 'CMS_PAGE_PUBLISHING';
export const CMS_SITE_MAP = 'CMS_SITE_MAP';
export const CMS_SITE_SEARCH = 'CMS_SITE_SEARCH';
export const CMS_TEMPLATES = 'CMS_TEMPLATES';
export const CMS_URL_MAPPINGS = 'CMS_URL_MAPPINGS';
export const CRM_ASSOCIATIONS = 'CRM_ASSOCIATIONS';
export const CRM_EXTENSIONS = 'CRM_EXTENSIONS';
export const CRM_PIPELINES = 'CRM_PIPELINES';
export const DEALS = 'DEALS';
export const DEAL_PIPELINES = 'DEAL_PIPELINES';
export const DEAL_PROPERTIES = 'DEAL_PROPERTIES';
export const ECOMMERCE_BRIDGE = 'ECOMMERCE_BRIDGE';
export const EMAIL_ACTIVITIES = 'EMAIL_ACTIVITIES';
export const EMAIL_EVENTS = 'EMAIL_EVENTS';
export const EMAIL_SUBSCRIPTION = 'EMAIL_SUBSCRIPTION';
export const ENGAGEMENTS = 'ENGAGEMENTS';
export const EVENTS = 'EVENTS';
export const FORMS = 'FORMS';
export const INVOICES = 'INVOICES';
export const MARKETING_EMAIL = 'MARKETING_EMAIL';
export const MEETINGS = 'MEETINGS';
export const NOTES = 'NOTES';
export const NOTIFICATIONS = 'NOTIFICATIONS';
export const ORDERS = 'ORDERS';
export const OWNERS = 'OWNERS';
export const PLAYBOOKS = 'PLAYBOOKS';
export const PRODUCTS = 'PRODUCTS';
export const PRODUCT_PROPERTIES = 'PRODUCT_PROPERTIES';
export const SOCIAL_MEDIA = 'SOCIAL_MEDIA';
export const TASKS = 'TASKS';
export const TICKETS = 'TICKETS';
export const TIMELINE = 'TIMELINE';
export const TRACKING_CODE = 'TRACKING_CODE';
export const TRANSACTIONAL_EMAIL = 'TRANSACTIONAL_EMAIL';
export const WORKFLOWS = 'WORKFLOWS';
export const WEBHOOKS = 'WEBHOOKS';